import { Button, Flex, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

/**
 * "Not enough permissions" screen, ported from `ebs-platform-web`
 * (`apps/crm/src/components/Error/ForbiddenError.tsx`). Rendered in place of a
 * section the signed-in member lacks the permission code for.
 *
 * The action goes back where the user came from, falling back to a given path
 * (or the app root) when this was a fresh tab with no history to return to.
 */
type Props = {
  /** Where to send the user when there is no history to go back to. */
  fallbackPath?: string
  title?: string
  description?: string
}

export const ForbiddenError = ({
  fallbackPath = '/',
  title,
  description
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onGoBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      void navigate(fallbackPath)
    }
  }

  return (
    <Flex justify="center" align="center" className="h-full">
      <Result
        status={403}
        title={title ?? t('workspaces.accessDenied.insufficientRole.title')}
        subTitle={
          description ??
          t('workspaces.accessDenied.insufficientRole.description')
        }
        extra={
          <Button type="primary" onClick={onGoBack}>
            {t('back')}
          </Button>
        }
      />
    </Flex>
  )
}
